// utils/paymentGateway.js or similar

export const paymentGateway = (options) => {
    return new Promise((resolve, reject) => {
        if (!window.Razorpay) {
            reject("Razorpay SDK not loaded");
            return;
        }

        const rzp = new window.Razorpay({
            key: options.key, // e.g. 'rzp_test_ABC123xyz'
            amount: options.amount, // in paise (₹500 = 50000)
            currency: options.currency || "INR",
            name: options.name || "Your Company",
            description: options.description || "Payment",
            image: options.image, // Optional logo URL
            order_id: options.order_id, // From backend
            prefill: {
                name: options.prefill?.name,
                email: options.prefill?.email,
                contact: options.prefill?.contact,
            },
            notes: options.notes || {},
            theme: {
                color: options.themeColor || "#3399cc",
            },
            handler: function (response) {
                resolve(response); // Payment success
            },
            modal: {
                ondismiss: function (response) {
                    reject("Payment popup closed", JSON.stringify(response, null, 12));
                },
            },
        });

        rzp.open();
    });
};
